/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import {EEmbededElementTypes, RenderDocument} from "js_renderer";
import Point from "./point";
import {vec2, vec3} from "gl-matrix";
import Factory from "./factory";
import IGeoPoint from "./geo_point_interface";

export default
class GeoPoint extends Point implements IGeoPoint {

    public static TypeName: string = EEmbededElementTypes.GEOPOINT;
    private _isInside: boolean;

    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);

        this._isInside = false;

        // set default texture on each geoPoint
        this._properties.textureUrl = '@assets/images/gps_pos_marker.png';
        this._properties.textureSize = vec2.create();
        this._properties.glyphPosition = [0.0, 0.0];
        this._properties.glyphSize = [1.0, 1.0];
    }

    public static create(aRenderDocument: RenderDocument): GeoPoint {
        let element = new GeoPoint(aRenderDocument);
        element._typeName = GeoPoint.TypeName;
        return element;
    }

    /***
     * The elevation (y position) is computed based on aPosition 2D vector.
     *
     * @param {string} aEPSGCode EPSG code of coordinate system of the input a2DPoint
     * @param {vec2} a2DPoint A 2D position vector
     */
    public setPosition2D(aEPSGCode: string, a2DPoint: vec2) {
        this._position = this._sceneAPI.getDocument().transformCoordSystemToLocal(aEPSGCode, a2DPoint);

        let yValue = this._sceneAPI.pickingModule._getYValue(vec2.fromValues(this._position[0], this._position[2]));
        if (!yValue) {
            this._isInside = false;
            return;
        }

        this._position[1] = yValue;

        this.updatePositions([
            new Float32Array([this._position[0], this._position[1], this._position[2]])
        ]);

        this._isInside = true;
    }

    /***
     * The elevation is not computed.
     *
     * @param {string} aEPSGCode EPSG code of coordinate system of the input a2DPoint
     * @param {vec3} a3DPoint A 3D position vector [lat, lon, alt] lat, lon in decimal degrees???, alt in meters
     */
    public setPosition3D(aEPSGCode: string, a3DPoint: vec3) {
        this._position = this._sceneAPI.getDocument().transformCoordSystemToLocal(aEPSGCode, [a3DPoint[0], a3DPoint[1]]);

        // let yValue = this._sceneAPI.pickingModule._getYValue(vec2.fromValues(this._position[0], this._position[2]));

        this._position[1] = a3DPoint[2];

        this.updatePositions([
            new Float32Array([this._position[0], this._position[1], this._position[2]])
        ]);

        this._isInside = true;
    }

    public isInsideScene(): boolean {
        return this._isInside;
    }
}

Factory.register(GeoPoint);
